"use strict";
import Splide from "@splidejs/splide";

export default function setupExpeditionFilters() {
    const is_page_home = document.querySelector(".home");
    if (!is_page_home) return;
    /* ============================================================
     * MOSTRAR / ESCONDER LOADING
     * ============================================================ */
    function showLoading() {
        const loading = document.querySelector(".o-expedition__loading");
        const slider = document.querySelector(".o-expedition__slider");

        if (loading) loading.style.display = "block";
        if (slider) slider.classList.add("is-loading");
    }

    function hideLoading() {
        const loading = document.querySelector(".o-expedition__loading");
        const slider = document.querySelector(".o-expedition__slider");

        if (loading) loading.style.display = "none";
        if (slider) slider.classList.remove("is-loading");
    }

    /* ============================================================
     * SPLIDE — reconstruir sempre
     * ============================================================ */
    function initExpeditionSlider() {
        const slider = document.querySelector(".o-expedition__slider.splide");
        if (!slider) return;

        if (window.splideExpedicoes instanceof Splide) {
            window.splideExpedicoes.destroy(true);
        }

        const splide = new Splide(slider, {
            rewind: true,
            perPage: 3,
            perMove: 1,
            gap: "16px",
            arrows: true,
            pagination: false,
            breakpoints: {
                1024: { perPage: 2 },
                768: { perPage: 1 },
            },
        });

        const bar = slider.querySelector(".my-slider-progress-bar");

        splide.on("mounted move", () => {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = (splide.index + 1) / end;
            if (bar) bar.style.width = `${rate * 100}%`;
        });

        splide.mount();
        window.splideExpedicoes = splide;
    }

    /* ============================================================
     * AJAX — atualizar expedições
     * ============================================================ */
    function atualizarExpedicoes() {
        showLoading(); // <- mostra skeleton/spinner

        const destino =
            document.querySelector('[data-filter="destinos"]')?.dataset.value ||
            "";
        const mes =
            document.querySelector('[data-filter="data"]')?.dataset.value || "";
        const pref =
            document.querySelector('[data-filter="preferencias"]')?.dataset
                .value || "";

        const url =
            `/wp-admin/admin-ajax.php?action=filtrar_expedicoes` +
            `&destino=${encodeURIComponent(destino)}` +
            `&mes=${encodeURIComponent(mes)}` +
            `&preferencia=${encodeURIComponent(pref)}`;

        fetch(url)
            .then((r) => r.text())
            .then((html) => {
                const list = document.querySelector(
                    ".o-expedition__slider .splide__list"
                );
                if (!list) return;

                list.innerHTML = html;

                if (!list.querySelector(".splide__slide")) {
                    hideLoading();
                    return;
                }

                initExpeditionSlider();
                hideLoading();
            });
    }

    /* ============================================================
     * LISTENER DE TODOS OS SELECTS
     * ============================================================ */
    document.addEventListener("click", function (e) {
        const option = e.target.closest(".c-select__option");
        if (!option) return;

        if (option.classList.contains("is-disabled")) return;

        const select = option.closest(".c-select");
        const field = select.dataset.filter;
        const value = option.dataset.value;

        select.querySelector(".c-select__label").innerText =
            option.innerText.trim();
        select.dataset.value = value;

        /* DESTINO */
        if (field === "destinos") {
            showLoading();

            fetch(
                `/wp-admin/admin-ajax.php?action=get_meses_expedicao&destino=${value}`
            )
                .then((r) => r.json())
                .then((data) => {
                    const dropdown = document.querySelector(
                        '[data-filter="data"] .c-select__dropdown'
                    );
                    const label = document.querySelector(
                        '[data-filter="data"] .c-select__label'
                    );

                    dropdown.innerHTML = "";
                    label.innerText = "Data";

                    if (!data.length) {
                        dropdown.innerHTML = `<button class="c-select__option is-disabled" disabled>Nenhuma data</button>`;
                    } else {
                        data.forEach(
                            (mes) =>
                                (dropdown.innerHTML += `<button class="c-select__option" data-value="${mes}">${mes}</button>`)
                        );
                    }
                });

            fetch(
                `/wp-admin/admin-ajax.php?action=get_preferencias_expedicao&destino=${value}`
            )
                .then((r) => r.json())
                .then((data) => {
                    const dropdown = document.querySelector(
                        '[data-filter="preferencias"] .c-select__dropdown'
                    );
                    const label = document.querySelector(
                        '[data-filter="preferencias"] .c-select__label'
                    );

                    dropdown.innerHTML = "";
                    label.innerText = "Preferências";

                    const slugs = Object.keys(data);

                    if (!slugs.length) {
                        dropdown.innerHTML = `<button class="c-select__option is-disabled" disabled>Nenhuma preferência</button>`;
                    } else {
                        slugs.forEach(
                            (slug) =>
                                (dropdown.innerHTML += `<button class="c-select__option" data-value="${slug}">${data[slug]}</button>`)
                        );
                    }
                });

            atualizarExpedicoes();
            return;
        }

        /* DATA */
        if (field === "data") {
            atualizarExpedicoes();
            return;
        }

        /* PREFERÊNCIA */
        if (field === "preferencias") {
            atualizarExpedicoes();
            return;
        }
    });

    /* ============================================================
     * SPLIDE NA CARGA INICIAL
     * ============================================================ */
    document.addEventListener("DOMContentLoaded", initExpeditionSlider);
}
